import { KnowledgeBar, KnowledgeView } from "./KnowledgeBar";
import { KnowledgePanel } from "./KnowledgePanel";

interface KnowledgeSidebarProps {
  activeView: KnowledgeView;
  onViewChange: (view: KnowledgeView) => void;
}

export function KnowledgeSidebar({
  activeView,
  onViewChange
}: KnowledgeSidebarProps) {
  return (
    <div className="flex h-full" style={{ width: '100%' }}>
      {/* Knowledge Panel - Conditionally visible */}
      {activeView && (
        <div className="border-l flex-1 min-w-0 overflow-hidden">
          <KnowledgePanel activeView={activeView} />
        </div>
      )}
      
      {/* Knowledge Bar - Always visible with absolute fixed width */}
      <div style={{ width: '48px', minWidth: '48px', maxWidth: '48px', flexShrink: 0, flexGrow: 0, flex: '0 0 48px' }}>
        <KnowledgeBar 
          activeView={activeView}
          onViewChange={onViewChange}
        />
      </div>
    </div>
  );
}
